import { Box } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';

type Item = { [index: string]: any };

interface Props {
  onSelect?: (item: Item) => void;
  text: string | JSX.Element;
  focused?: boolean;
  classNames?: {
    focused?: string;
    common?: string;
  };
}

/**
 * AutocompleteMenuItem.
 */
const AutocompleteMenuItem = (props: Props) => {
  const { onSelect, text, focused, classNames } = props;

  return (
    <Box
      data-testid="auto-complete-menu-item"
      onClick={onSelect}
      role="option"
      tabIndex={-1}
      className={`cursor-pointer rounded p-2 hover:bg-gray-100 ${
        classNames?.common || ''
      }  ${
        focused
          ? `bg-gray-100 ${classNames?.focused || ''} ring-2 ring-blue-500`
          : ''
      }`}
    >
      {text}
    </Box>
  );
};

export default AutocompleteMenuItem;
